<dojo-master-list-view
  [searchPlaceholder]="'home_card.search_topics' | transloco"
  [columnDefs]="columnDefs"
  [gridOptions]="gridOptions"
  [showToolbarAddButton]="false"
  [messages]="messages()"
  class="dojo-list-view grow"
  [showAddButtonIcon]="false"
  [hideNumberOfEntries]="true"
  [hideToolbarWhenNoData]="true"
  (gridSelectionChanged)="onGridSelectionChanged($event)"
  (gridRowClicked)="onGridRowClicked($event)"
>
  @if (showToolbarActions()) {
    <div additionalToolbarActions class="toolbar-actions">
      <div class="flex w-full items-center gap-4 md:w-auto">
        @if (numberOfSelectedEntries() > 0) {
          <div class="text-secondary whitespace-nowrap text-sm">
            {{ 'entries_selected' | transloco: { count: numberOfSelectedEntries() } }}
          </div>
        }
        <dojo-list-view-external-filtering class="filter-wrap" />
        <dojo-list-view-external-sorting class="filter-wrap" />
      </div>
    </div>
  }
</dojo-master-list-view>
